import i18n from 'i18nextInstance';

export const TABLE = [{
    key: 'last_name',
    label: i18n.t('Apellido')
}, {
    key: 'first_name',
    label: i18n.t('Nombre')
}, {
    key: 'identification',
    label: i18n.t('DNI')
}, {
    key: 'time',
    label: i18n.t('Tiempo Acumulado')
}];

export const downloadHeaders = [{
    key: 'identification',
    label: i18n.t('DNI')
}, {
    key: 'last_name',
    label: i18n.t('Apellido')
}, {
    key: 'first_name',
    label: i18n.t('Nombre')
}, {
    key: 'time_from',
    label: i18n.t('Desde')
}, {
    key: 'time_to',
    label: i18n.t('Hasta')
}, {
    key: 'time',
    label: i18n.t('Duración')
}, {
    key: 'seconds',
    label: `(${ i18n.t('Segundos') })`
}];
